import { render, staticRenderFns } from "./TopUpMethod.vue?vue&type=template&id=07ea11b4&"
import script from "./TopUpMethod.vue?vue&type=script&lang=js&"
export * from "./TopUpMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports